
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PlusCircle, Sprout } from 'lucide-react';

interface EmptyHarvestStateProps {
  farmId?: string;
}

const EmptyHarvestState: React.FC<EmptyHarvestStateProps> = ({ farmId }) => {
  const navigate = useNavigate();

  const handleAddHarvest = () => {
    if (farmId) {
      navigate(`/harvests/new?farmId=${farmId}`);
    } else {
      navigate('/harvests/new');
    }
  };

  return (
    <div className="text-center py-12">
      <Sprout className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {farmId ? 'No harvests scheduled' : 'No harvests found'}
      </h3>
      <p className="text-gray-500 mb-6">
        {farmId 
          ? 'Get started by scheduling your first harvest for this farm.'
          : 'Get started by scheduling your first harvest.'
        }
      </p>
      <Button onClick={handleAddHarvest}>
        <PlusCircle className="mr-2 h-4 w-4" />
        Schedule Harvest
      </Button>
    </div>
  );
};

export default EmptyHarvestState;
